import React, { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Metrics from "../components/Metrics";
import About from "../components/About";
import LeadershipTracks from "../components/LeadershipTracks";
import Experience from "../components/Experience";
import Projects from "../components/Projects";
import VendorEcosystem from "../components/VendorEcosystem";
import SkillsEducation from "../components/SkillsEducation";
import Press from "../components/Press";
import Articles from "../components/Articles";
import ClosingCTA from "../components/ClosingCTA";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const HomePage = () => {
  useEffect(() => {
    document.title =
      "Hassan M Allahham — Business, Technology & Operations Executive | UAE · KSA · Oman";
  }, []);

  return (
    <div className="bg-ivory-50 text-ink">
      <Header />
      <main>
        <Hero />
        <Metrics />
        <About />
        <LeadershipTracks />
        <Experience />
        <Projects />
        <VendorEcosystem />
        <SkillsEducation />
        <Press />
        <Articles />
        <ClosingCTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
